const mutations = {
  setServiceAnnotationsModified(state, data) {
    state.serviceAnnotationsModified = data
  }
}

export default mutations